// js/components/CollapsibleManager.js
import Delegate from 'ftdomdelegate';
import { Animation } from 'utils';

export class CollapsibleManager extends HTMLElement {
  constructor() {
    super();
    this.domDelegate = new Delegate(this);
    this._attachListeners();
  }

  connectedCallback() {
    // check if [data-action="toggle-collapsible"] should be visible by comparing expandable-content with first div child height
    if (this.querySelector('.expandable-content')?.firstElementChild?.clientHeight > 0) {
      this.querySelector('[data-action="toggle-collapsible"]')?.classList.add('visible');
    }
  }

  _attachListeners() {
    this.domDelegate.on("click", '[data-action="toggle-collapsible"]:not([disabled])', this._toggleCollapsible.bind(this));
    // document.addEventListener("collapsible:toggle", this._toggleCollapsible.bind(this));
  }

  /**
   * Toggle a given collapsible
   */
  _toggleCollapsible(event2, target) {
    if (!target && event2.detail) {
      target = document.querySelector(`[aria-controls="${event2.detail.id}"]`);
    }
    const isOpen = target.getAttribute("aria-expanded") === "true", parentCollapsible = target.parentNode;
    if (isOpen) {
      this._close(target, parentCollapsible);
    } else {
      this._open(target, parentCollapsible);
    }
    if (target.getAttribute("data-close-siblings") !== "false") {
      this.querySelectorAll('[data-action="toggle-collapsible"][aria-expanded="true"]').forEach((collapsibleToClose) => this._close(collapsibleToClose, parentCollapsible));
    }
  }

  /**
   * Open a given collapsible
   */
  _open(target, collapsible) {
    if (target.getAttribute("aria-expanded") === "true") return;

    let collapsibleContent = collapsible.querySelector(`#${target.getAttribute("aria-controls")}`);
    if (!collapsibleContent) return;

    target.setAttribute("aria-expanded", "true");
    if (collapsibleContent.hasAttribute("aria-hidden")) {
      collapsibleContent.setAttribute("aria-hidden", "false");
    }
    Animation.slideDown(collapsibleContent, () => {
      if (target.hasAttribute("data-collapsible-force-overflow")) {
        collapsibleContent.style.overflow = "visible";
      }
      let autofocusElement = collapsibleContent.querySelector("[autofocus]");
      if (autofocusElement) {
        autofocusElement.focus();
      }
    });
  }

  /**
   * Close a given collapsible
   */
  _close(target, collapsible) {
    if (target.getAttribute("aria-expanded") === "false") return;    

    let collapsibleContent = collapsible.querySelector(`#${target.getAttribute("aria-controls")}`);
    if (!collapsibleContent) return;
    
    if (target.hasAttribute("data-collapsible-force-overflow")) {
      collapsibleContent.style.overflow = "hidden";
    }
    if (collapsibleContent.hasAttribute("aria-hidden")) {
      collapsibleContent.setAttribute("aria-hidden", "true");
    }
    target.setAttribute("aria-expanded", "false");
    Animation.slideUp(collapsibleContent);
  }

}

if (!customElements.get("cos-collapsible")) customElements.define("cos-collapsible", CollapsibleManager);
